export const extractFilespaceSettings = (globalSettings) => {
    if (!globalSettings || !globalSettings?.length) {
        return undefined;
    }
    return globalSettings.reduce((previousValue, currentValue) => {
        const { default: defaultValue, isDefault, value } = currentValue;
        previousValue[currentValue.fullName] = {
            value,
            default: defaultValue,
            isDefault,
        };
        return previousValue;
    }, {});
};
